// extracted by mini-css-extract-plugin
export default {"ToggleButton":"style_ToggleButton__YiVnV"};